// ABOUTME: Configuration definitions for different external channel types
// ABOUTME: Defines fields, default values, and settings for external channel integrations (Prediko, etc.)

export const externalChannelTypeConfigurations = {
    prediko: {
        fields: [
            { name: 'apiKey', type: 'password', label: 'api_key', required: true },
            { name: 'syncSuccessfulInbound', type: 'boolean', label: 'sync_successful_inbound', default: false }
        ],
        saveObject: {
            apiKey: '',
            syncProducts: true,
            syncInventory: true,
            syncSuccessfulInbound: false
        }
    },
    // Outlook holds no credentials of its own: the mailbox is connected through the OAuth
    // button on the channel sidepanel, which stores the tokens server-side.
    outlook: {
        fields: [],
        saveObject: {}
    },
    // A mailbox at a regular hosting provider, used like Outlook to mail shipper claims. The
    // password is write-only: the backend stores it encrypted and never sends it back, so the
    // field stays empty and only replaces the stored password when something is typed.
    smtpimap: {
        fields: [
            { name: 'emailAddress', type: 'text', label: 'emailaddress', required: true },
            { name: 'username', type: 'text', label: 'username', tooltip: 'smtp_imap_username_tooltip' },
            { name: 'password', type: 'password', label: 'password', required: true, writeOnly: true },
            { name: 'smtpHost', type: 'text', label: 'smtp_server', required: true },
            { name: 'smtpPort', type: 'number', label: 'smtp_port', default: 587, min: 1, max: 65535, step: 1 },
            { name: 'imapHost', type: 'text', label: 'imap_server', required: true },
            { name: 'imapPort', type: 'number', label: 'imap_port', default: 993, min: 1, max: 65535, step: 1 }
        ],
        saveObject: {
            emailAddress: '',
            username: '',
            password: '',
            smtpHost: '',
            smtpPort: 587,
            imapHost: '',
            imapPort: 993
        }
    },
    // Ampere is a warehouse channel: it registers parcels as ready for collection on the
    // fulfilment gateway. Ampere issues every fulfilment centre its own m2m client, and that
    // client already identifies us, so the channel carries nothing but its credentials.
    ampere: {
        fields: [
            { name: 'clientId', type: 'text', label: 'client_id', required: true },
            { name: 'clientSecret', type: 'password', label: 'client_secret', required: true, writeOnly: true }
        ],
        saveObject: {
            clientId: '',
            clientSecret: ''
        }
    },
    returnless: {
        fields: [
            { name: 'apiKey', type: 'password', label: 'api_key', required: true },
            // {
            //     name: 'approvalMethod',
            //     type: 'dropdown',
            //     label: 'approval_method',
            //     required: false,
            //     default: 'approve',
            //     options: [
            //         { label: 'approve', value: 'approve', translate: true },
            //         { label: 'approve_without_shipment', value: 'approve_without_shipment', translate: true },
            //         { label: 'approve_with_manual_shipment', value: 'approve_with_manual_shipment', translate: true },
            //     ]
            // },
            // { name: 'finalizedStatusId', type: 'number', label: 'finalized_status_id', required: false },
        ],
        saveObject: {
            apiKey: ''
            // approvalMethod: 'approve',
            // finalizedStatusId: '',
        }
    },
    // Zonos is linked by a relation that ships to the United States with PostNL. The
    // organization id goes on the PostNL label, the api token is used to read (and when
    // chosen, write) the relation's Zonos catalog.
    zonos: {
        fields: [
            { name: 'apiKey', type: 'password', label: 'api_key', required: true },
            { name: 'organizationId', type: 'text', label: 'zonos_organization_id', tooltip: 'zonos_organization_id_tooltip', required: true },
            { name: 'syncMode', type: 'dropdown', label: 'zonos_sync_mode', tooltip: 'zonos_sync_mode_tooltip', translate: true, default: 'ids', options: [
                { label: 'zonos_sync_mode_ids', value: 'ids' },
                { label: 'zonos_sync_mode_ids_and_products', value: 'ids_and_products' },
            ] },
        ],
        saveObject: {
            apiKey: '',
            organizationId: '',
            syncMode: 'ids'
        }
    }
    // Future channel types can be added here (e.g., cin7, other integrations)
    // Supported field types (same as shipperTypeConfigurations):
    // - text: Standard text input
    // - password: Password input (masked)
    // - boolean: Yes/No toggle (styled with red/green pill toggles)
    // - number: Numeric input with optional min/max/step
    // - dropdown: Single selection dropdown with options array
    // - multidropdown: Multiple selection dropdown
    // Field options:
    // - name: Field identifier
    // - type: Field type (see above)
    // - label: Translation key for field label
    // - required: Boolean for validation
    // - default: Default value
    // - tooltip: Translation key for help tooltip (optional)
    // - options: Array of {label, value} for dropdowns (can use translate: true for i18n)
    // - conditional: {field: 'fieldName', value: 'expectedValue'} to show/hide conditionally
    // - writeOnly: the stored value is never sent back, the backend reports has<Name> instead
    //   (password -> hasPassword, clientSecret -> hasClientSecret); an empty field keeps the stored value
    // - min/max/step: For number fields
};
